import { Card } from "react-bootstrap";
import { UpdateOrderWastesDetails } from "../../../useCases/orders/updateWastesDetails/UpdateOrderWastesDetails";
import { BadgeDomain } from "../../Abstractions/BadgeDomain";
import { OrderLineItem } from "./OrderDetailsView";
import React from "react";
import { YesNoBadge } from "../../Abstractions/YesNoBadge";
import { WasteDifferenceReason } from "../../../domain/WasteDifferenceReason";
import { UpdateOrderSeriesWastesDetails } from "../../../useCases/orders/updateWastesDetails/UpdateOrderSeriesWastesDetails";
import { WasteFormType } from "../../../domain/WasteFormType";
import { Hr } from "../../Abstractions/Hr/Hr";
import { ServicePricingType } from "../../../domain/ServicePricingType";
import { AttachRatePlanToOrder } from "../../../useCases/orders/workflowActions/AttachRatePlanToOrder";
import { AttachWeighbridgeTicketsToOrder } from "../../../useCases/orders/weighbridgeTickets/AttachWeighbridgeTicketsToOrder";
import { ORDER_STATUS } from "../../../domain/Orders/OrderStatus";

export function WastesOrderDetailsView({ item, isOrderSeries = false }) {
  const { id, status, transactionType, wastesDetails, orderRatePlanDetails } = item;
  const { isWasteTransport } = wastesDetails || {};
  const isPurchase = transactionType === "Purchase";
  const isSale = transactionType === "Sale";
  const isTransport = transactionType === "Transport";
  const showTicketsWarnings =
    status === ORDER_STATUS.TRANSPORT_CONFIRMED ||
    status === ORDER_STATUS.RECEIVE_CONFIRMED ||
    status === ORDER_STATUS.TRANSPORT_COMPLETED;

  return <Card className="h-100">
    <Card.Header className="d-flex align-items-center justify-content-between">
      Dane towarów i usług
      <div className="d-flex gap-1">
        {!isOrderSeries && <AttachWeighbridgeTicketsToOrder order={item} orderId={id} />}
        {!isOrderSeries ?
          <UpdateOrderWastesDetails order={item} wastesDetails={wastesDetails} transactionType={transactionType} orderId={id}/> :
          <UpdateOrderSeriesWastesDetails series={item} wastesDetails={wastesDetails} transactionType={transactionType}/>}
      </div>
    </Card.Header>
    <Card.Body>
      <OrderLineItem name="Integracja z BDO"><YesNoBadge value={item?.wastesDetails?.isBdoIntegrated}/></OrderLineItem>
      {item.orderRatePlanDetails && <OrderLineItem name="Cennik">
        {orderRatePlanDetails?.description} <AttachRatePlanToOrder orderId={item.id} orderRatePlan={orderRatePlanDetails} isUpdate />
      </OrderLineItem>}
      {(isPurchase || isWasteTransport) && <>
        <OrderLineItem name="Nr. PZ">{wastesDetails?.receivedNoteNumber}</OrderLineItem>
        <OrderLineItem name="Nr. faktury zakupu">{wastesDetails?.internalInvoiceNumber}</OrderLineItem>
      </>}
      {(isSale || isWasteTransport) && <>
        <OrderLineItem name="Nr. WZ">{wastesDetails?.deliveryNoteNumber ?? "-"}</OrderLineItem>
        <OrderLineItem name="Nr. faktury sprzedaży">{wastesDetails?.externalInvoiceNumber}</OrderLineItem>
      </>}
      {!isTransport &&
      <OrderLineItem name="Nr. kwitów wagowych">{wastesDetails?.weighbridgeTickets?.length > 0 ?
        wastesDetails?.weighbridgeTickets.map(x => x.ticketNumber).join(", ") :
        wastesDetails?.weighbridgeTicketNumber}</OrderLineItem>}
      {isTransport && <>
        <OrderLineItem name="Transport z TRK"><YesNoBadge value={item?.wastesDetails?.isWasteTransport}/></OrderLineItem>
      </>}
      {wastesDetails?.wasteExchanges?.length > 0 && <div className="mt-2"><b>Towary</b><Hr/></div>}
      <div>{wastesDetails?.wasteExchanges?.map((w, idx) => {
        const exchangeTicketNumbers = wastesDetails?.weighbridgeTickets
          ?.filter(t => t.wasteExchangeId === w.wasteExchangeId)
          ?.map(t => t.ticketNumber)
          ?.join(", ");

        return item.transactionType === "Purchase" ? (<Card key={idx} className="mb-1">
          <Card.Header className="d-flex align-items-center justify-content-between">
            <span>{w.isContainer ? `Kontener ${w.containerNumber} - ${w.containerName?.toUpperCase()}` : "Załadunek"}</span>
            {exchangeTicketNumbers
              ? <BadgeDomain bg="pink" size="x-small">Kwit wagowy: {exchangeTicketNumbers}</BadgeDomain>
              : showTicketsWarnings && <BadgeDomain bg="danger" size="x-small">Brak kwitów</BadgeDomain>}
          </Card.Header>
          <Card.Body>
            {w.wastes.map((x, idx) => <Card.Text className="upper" key={idx}>
              <BadgeDomain>{x.code}</BadgeDomain> {x.internalName} ({x.wasteKindName ?? "-"})
              {x.wasteFormType && " - "}{WasteFormType[x.wasteFormType]}
              {" "}{x.wasteMass ? `: ${x.wasteMass?.toFixed(4)} [Mg]` : ""}
            </Card.Text>)}
          </Card.Body>
        </Card>) : w.wastes.map((x, idx) => {
          const incomeType = x.extendedData?.isRevenue ? "PW" : "RW";
          return <div className=" upper" key={idx}>
            <Card.Text>
              <BadgeDomain>{x.code}</BadgeDomain> {x.internalName} ({x.wasteKindName ?? "-"}): <b>{x.wasteMass?.toFixed(4)} [Mg]</b>
            </Card.Text>
            {x.extendedData && x.extendedData?.deductions !== 0 && <div>
              Początkowa masa: <b>{x.extendedData?.initWasteMass?.toFixed(4)}</b> <br/>
              <>Potrącenia: <b>{x.extendedData?.deductions?.toFixed(4)} [Mg]</b> <br/>
                {" "}Masa {incomeType}: <b>{x.extendedData?.revenueWasteMass?.toFixed(4)} [MG]</b></>
              <br/>
              {x.extendedData?.deductions !== 0 && <>
                <>Dokument {incomeType}: <b>{x.extendedData?.revenueDocumentNumber}</b></>
                <br/>
                <>Przyczyny: <b>{x.extendedData?.wasteDifferenceReasons?.map(x => WasteDifferenceReason[x]).join(", ")}</b></>
                {x.extendedData?.wasteDifferenceOtherReason && <><b> ({x.extendedData?.wasteDifferenceOtherReason})</b></>}
              </>}
              <div className="mt-2"/>
            </div>}
          </div>;
        });
      })}</div>
      {wastesDetails?.services?.length > 0 && <div className="mt-2"><b>Usługi</b><Hr/></div>}
      <div>{wastesDetails?.services?.map((x, idx) => {
        return (<div key={idx} className="mb-1">
            <Card.Text className="upper" key={x.serviceId}>
              <BadgeDomain bg="info">{x.service?.name}</BadgeDomain> ({ServicePricingType[x.pricingType] ?? "-"})
              {/*{x.service?.name} ({ServicePricingType[x.pricingType] ?? "-"})*/}
            </Card.Text>
        </div>);
      })}</div>
    </Card.Body>
  </Card>;

}